import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import { handleScrollTop } from "shared/helpers/scrollTo";
import {
  Container,
  Icon,
  Button,
  Modal,
  Responsive,
  Header
} from "semantic-ui-react";

import { getUserRole } from "shared/selectors";
import { getBottomNavigationModel } from "shared/selectors/unit";
import { toggleCompletionDialog } from "shared/actions/dialogActions";
import { withRouter } from "../../helpers/withRouter";
import { dispatchEventAction } from "../../actions/eventActions";

import "./bottomNavigation.scss";

class BottomNavigation extends React.Component {
  static propTypes = {
    prev: PropTypes.object,
    next: PropTypes.object,
    userRole: PropTypes.string
  };

  constructor(props) {
    super(props);

    this.state = {
      confirm: null
    };
  }

  render() {
    const { next, hideBackButton, showCompletionButton } = this.props;

    if (next) {
      return (
        <div data-component="bottomNavigation">
          {this.renderReminderModal()}
          <Container>
            <Responsive minWidth={768}>
              {showCompletionButton && this.renderCompletionButton()}
              {!hideBackButton && (
                <Button
                  onClick={this.navigateBack}
                  basic
                  content="Zurück"
                  size="huge"
                  className="left floated element secondary"
                />
              )}
              {this.renderButton(next, "right", next.color, {})}
            </Responsive>
            <Responsive maxWidth={767}>
              {this.renderButton(next, "right", next.color, {
                fluid: true,
                icon: next.iconMobile,
                content: next.labelMobile || next.label
              })}
              {showCompletionButton &&
                this.renderCompletionButton({
                  direction: "left",
                  active: false,
                  fluid: true
                })}
            </Responsive>
          </Container>
        </div>
      );
    }
    if (showCompletionButton) {
      return (
        <div data-component="bottomNavigation">
          {this.renderReminderModal()}
          <Container>
            <Responsive minWidth={768}>
              {this.renderCompletionButton({
                direction: "right",
                active: true
              })}
            </Responsive>
            <Responsive maxWidth={767}>
              {this.renderCompletionButton({
                direction: "right",
                active: true,
                fluid: true
              })}
            </Responsive>
          </Container>
        </div>
      );
    }
    return null;
  }

  renderCompletionButton = (props = {}) => {
    const { toggleCompletionDialog } = this.props;
    const { direction, active, fluid } = props;
    return (
      <Button
        id="completion"
        basic={!active}
        size="huge"
        fluid={fluid}
        className={`${direction || "left"} floated element ${
          active ? "primary" : "secondary"
        }`}
        content="Konfiguration abschliessen"
        onClick={() => {
          toggleCompletionDialog(true);
        }}
      />
    );
  };

  renderReminderModal() {
    const { confirm } = this.state;

    if (confirm) {
      return (
        <Modal
          size="small"
          closeOnEscape
          closeOnDimmerClick
          open
          onClose={() => this.setState({ confirm: null })}
          data-component="reminderModal"
        >
          <Modal.Content>
            <Header as="h3">
              <Icon name="exclamation triangle" color="orange" />
              <Header.Content>
                {confirm.confirmation.title}
                <Header.Subheader>
                  {confirm.confirmation.message}
                </Header.Subheader>
              </Header.Content>
            </Header>
          </Modal.Content>
          <Modal.Actions>
            <Button
              onClick={() => {
                this.navigateTo(confirm.path);
              }}
              basic
              content="Ja"
              size="large"
              className="secondary"
            />
            <Button
              onClick={this.closeReminder}
              basic
              content="Nein"
              size="large"
              className="secondary"
            />
          </Modal.Actions>
        </Modal>
      );
    }
  }

  renderButton = (navigation, orientation, colorCls, props = {}) => {
    if (navigation) {
      return (
        <Button
          onClick={this.triggerNavigationFn(navigation)}
          basic={navigation.basic}
          content={navigation.label}
          size="huge"
          className={`branded-button ${orientation} floated element ${colorCls}`}
          {...props}
        />
      );
    }
  };

  navigateBack = () => {
    const { router } = this.props;
    router.goBack();
  };

  triggerNavigationFn = navigation => {
    const { userRole, triggerEventAction } = this.props;
    const roleMayNeedConfirmation = ["admin", "buyer"].includes(userRole);

    return () => {
      triggerEventAction(navigation.eventAction).then(() => {
        if (roleMayNeedConfirmation && navigation.confirmation) {
          this.setState({ confirm: navigation });
        } else {
          this.navigateTo(navigation.path);
        }
      });
    };
  };

  navigateTo = path => {
    const { router } = this.props;
    this.closeReminder();
    handleScrollTop();
    router.push(path);
  };

  closeReminder = () => {
    this.setState({ confirm: false });
  };
}

const mapStateToProps = (state, props) => {
  const { i18n } = state;
  const userRole = getUserRole(state);
  return {
    i18n,
    userRole,
    ...getBottomNavigationModel(state, props)
  };
};

const mapDispatchToProps = dispatch => {
  return {
    toggleCompletionDialog: toggleCompletionDialog(dispatch),
    triggerEventAction: event => {
      return dispatchEventAction(dispatch, event);
    }
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(BottomNavigation)
);
